"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOutcomeKey = getOutcomeKey;
// todo: do we need to escape param value ?
function getOutcomeKey(probability) {
    const { outcomeTypeId, parameters } = probability;
    const key = parameters.reduce((str, parameter) => {
        return `${str}:${parameter.type}:${parameter.value}`;
    }, String(outcomeTypeId));
    return key;
}
//# sourceMappingURL=getOutcomeKey.js.map